import React, { useState, useEffect } from 'react';
import styles from '../styles/BannerCarousel.module.css';
import slide1 from '../assets/images/slide1.jpg';
import slide2 from '../assets/images/slide2.jpg';
import slide3 from '../assets/images/slide3.jpg';
import slide4 from '../assets/images/slide4.jpg';

const BannerCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const banners = [
    { id: 1, image: slide1, alt: 'Banner 1' },
    { id: 2, image: slide2, alt: 'Banner 2' },
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + banners.length) % banners.length);
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 15000); // Troca de banner a cada 5 segundos
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.carouselContainer}>
      <button className={`${styles.carouselButton} ${styles.left}`} onClick={prevSlide}>
        ❮
      </button>
      <div
        className={styles.carousel}
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {banners.map((banner) => (
          <div key={banner.id} className={styles.slide}>
            <img src={banner.image} alt={banner.alt} className={styles.bannerImage} />
          </div>
        ))}
      </div>
      <button className={`${styles.carouselButton} ${styles.right}`} onClick={nextSlide}>
        ❯
      </button>
    </div>
  );
};

export default BannerCarousel;